import React, { Fragment, Dispatch, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TextField from '@material-ui/core/TextField';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Checkbox from '@material-ui/core/Checkbox';
import AddIcon from '@material-ui/icons/Add';
import clsx from 'clsx';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { brandDisplayMapping, getNewBrand, getNewlyAddedBrand } from '../../common/components/util';
import { RESTRICTED_ACCESS } from '../../constants/restrictedAccessConstants';
import _, { get } from "lodash";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import InputAdornment from "@material-ui/core/InputAdornment";
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import CloseIcon from '@material-ui/icons/Close';
import { searchProducts, removeProductData } from "../../store/actions/products.actions";
import { AnyRecord } from 'dns';
import { addAnnxurePart } from '../../store/actions/annexureParts.actions';
import WarningIcon from "@material-ui/icons/Warning";
import DialogContentText from '@material-ui/core/DialogContentText';
import { Dialog, FormControl, InputLabel, OutlinedInput, Select } from "@material-ui/core";
import FullscreenLoader from "./../../common/components/FullscreenLoader";
import { Box } from "@material-ui/core";
import { getAnnexureList, updateAnnexurePart, deleteAnnexurePart, editAnnexurePart } from '../../store/actions/annexureParts.actions';
import Tooltip from '@material-ui/core/Tooltip';

const headCells = [
    { id: 'SrNo', numeric: true, disablePadding: true, label: 'Sr. No.' },
    { id: 'Part No', numeric: true, disablePadding: true, label: 'Part No' },
    { id: 'Desc', numeric: false, disablePadding: true, label: 'Desc' },
    { id: 'qty', numeric: true, disablePadding: true, label: 'Qty' },
    { id: 'Brand', numeric: false, disablePadding: true, label: 'Brand' },
    { id: 'action', numeric: true, disablePadding: true, label: 'Action' },
];

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    icon: {
        float: "left",
        margin: "0 20px 20px 0",
        height: "100%",
        fill: "white",
    },
    header: {
        color: "#133F8A",
        fontWeight: 900,
        fontSize: "0.813rem",
        fontFamily: 'Nunito'
    },
    title: {
        flex: '1 1 100%',
    },
    buttonDel: {
        color: "#1A9FE0",
        fontSize: '0.625rem',
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        float: 'right'
    },
    logoutText: {
        color: '#616161',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'inherit',
        textAlign: 'left',        // <-- key change
        lineHeight: '1.6',
        paddingLeft: '8px'        // <-- ensures alignment under the icon
    },
    yes: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#1A9FE0',
        textTransform: 'capitalize'
    },
    cancel: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#919191',
        textTransform: 'capitalize'
    },
    buttonIconDel: {
        color: "#1A9FE0",
    },
    buttonExcel: {
        fontSize: '0.75rem',
        textTransform: "none",
        color: "#1A9FE0",
        float: "right",
    },
    buttonAdd: {
        margin: "0.6rem 0.6rem 0.6rem 1.2rem",
        fontSize: 35,
        borderRadius: 45,
        height: 35,
        width: 35,
        textTransform: 'none',
    },
    tablehead: {
        color: "#133F8A",
        fontSize: "0.813rem",
        fontFamily: 'Nunito',
        fontWeight: 900,
    },
    bodyContent: {
        color: '#666666',
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 600
    },
    createButton: {
        backgroundColor: '#1A9FE0',
        width: 140,
        fontWeight: 800,
        textTransform: 'inherit',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#FFFFFF',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 8
    },
    closeButton: {
        backgroundColor: '#EAEAEA',
        width: 140,
        fontWeight: 800,
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#666666',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 24
    },
    addUpdateDailogTitle: {
        position: "absolute",
        top: 10,
        left: 10
    },
}));

export default function AddNewAnnexurePart(props: any) {
    const [selected, setSelected] = React.useState<any>([]);
    const [parts, setParts] = React.useState<any>([]);
    const [brands, setBrands] = React.useState([]);
    const [i, setIndex] = React.useState();
    const [name, setName] = React.useState('');
    const [addPart, setIsAddPart] = React.useState(false);
    const [isGlobalChecked, setIsGlobalChecked] = React.useState(false);
    const dispatch: Dispatch<any> = useDispatch();
    const { productsData } = useSelector((state: any) => state.products);
    const { createFavorite, favoritesDetails, favoritesList, updateFavorite }: any = useSelector((state: any) => state.favorites);
    const [nameError, showError] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<any>('');
    const [isValid, setIsValid] = React.useState<boolean>(true);
    const { enquirySessionId }: any = useSelector(
        (state: any) => state.createUpdateEnquiry
    );
    const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
    const { materialGroups }: any = useSelector((state: any) => state.materialGroups)
    const customerTierType = get(profileDetails, 'data.data.customerInfo.customerTierType', '');
    const customerTypeAccess = get(profileDetails, 'data.data.basicInfo.customerTypeAccess', '');
    let materialGroupsData = get(materialGroups, 'data.data', []);
    const b2bUserId = get(profileDetails, 'data.data.basicInfo.b2bUserId', "");
    const firstName = get(profileDetails, 'data.data.basicInfo.displayName', "");
    let inputRefs: any = [];
    let sapCustomerId: any = _.get(profileDetails, "data.data.basicInfo.sapCustomerId", "");
    const [partNumber, setPartNumber] = React.useState<any>([]);
    const [brand, setBrand] = React.useState<any>('');
    const [description, setDescription] = React.useState<any>('');
    const [selectedTab, setSelectedTab] = React.useState<any>([]);
    const [isValidPart, setIsValidPart] = React.useState<any>(false);
    const [openDialog, setOpenDialog] = React.useState<any>(false);
    const [partNumberError, setPartNumberError] = React.useState<any>(false);
    const [brandError, setBrandError] = React.useState<any>(false);
    const [descriptionError, setDescriptionError] = React.useState<any>(false);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState<any>(0);
    const [productList, setProductList] = React.useState<any>([]);
    // const [prices, setPrices] = React.useState<any>({});
    const [loading, setLoading] = React.useState<any>(false);
    const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const classes = useStyles();
    const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
    const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
    const [isDataUpdated, setIsDataUpdated] = React.useState(false);
    const rowsPerPage = 10;
    const { getAnnexureListData, editAnnexurePartDetails } = useSelector((state: any) => state.annexure)
    const [displayName, setDisplayName] = React.useState<any>('');

    type Tier = 1 | 2 | 3;
    type TierKey = `tier${Tier}`;
    type TierErrorKeys =
        | 'tier1Min' | 'tier2Min' | 'tier3Min' | 'tier3Max'
        | 'tier1Gold' | 'tier1Platinum' | 'tier1Elite'
        | 'tier2Gold' | 'tier2Platinum' | 'tier2Elite'
        | 'tier3Gold' | 'tier3Platinum' | 'tier3Elite';

    type TierData = { min: string; max?: string };

    type TiersState = Record<TierKey, TierData>;

    type PricesState = Record<TierKey, {
        gold?: string;
        platinum?: string;
        elite?: string;
    }>;

    const initialTiers: TiersState = {
        tier1: { min: '', max: '' },
        tier2: { min: '', max: '' },
        tier3: { min: '', max: '' },
    };

    const initialPrices: PricesState = {
        tier1: {},
        tier2: {},
        tier3: {
            platinum: '',
            elite: '',  // You may want to initialize these if you need the properties for Tier 3 prices
            gold: '',
        },
    };

    const [tiers, setTiers] = React.useState<TiersState>(initialTiers);
    const [prices, setPrices] = React.useState<PricesState>(initialPrices);

    const [errors, setErrors] = React.useState<Partial<Record<TierErrorKeys, string>>>({});
    const [showErrors, setShowErrors] = React.useState(false);

    const handleopenCloseErrorSnackbar = (open?: any) => {
        setOpenErrorSnackbar(open ? true : false);
    };

    useEffect(() => {
        if (props.isEdit && editAnnexurePartDetails?.data?.data?.productData?.length > 0) {
            const partData = editAnnexurePartDetails.data.data.productData[0];

            // Set basic part details
            setPartNumber(partData.partNumber || '');
            setDisplayName(partData.brand || '');
            setDescription(partData.description || '');

            // Set Quantity Tier Ranges
            const qt = partData.quantityTierRange || {};
            setTiers({
                tier1: { min: qt.tier_1?.minQty || '', max: qt.tier_1?.maxQty || '' },
                tier2: { min: qt.tier_2?.minQty || '', max: qt.tier_2?.maxQty || '' },
                tier3: { min: qt.tier_3?.minQty || '', max: qt.tier_3?.maxQty || '' },
            });

            // Set Price Tier Ranges
            const pt = partData.priceTierRange || {};
            setPrices({
                tier1: {
                    gold: pt.tier_1?.gold || '',
                    platinum: pt.tier_1?.platinum || '',
                    elite: pt.tier_1?.elite || ''
                },
                tier2: {
                    gold: pt.tier_2?.gold || '',
                    platinum: pt.tier_2?.platinum || '',
                    elite: pt.tier_2?.elite || ''
                },
                tier3: {
                    gold: pt.tier_3?.gold || '',
                    platinum: pt.tier_3?.platinum || '',
                    elite: pt.tier_3?.elite || ''
                }
            });

            // Reset any validation errors
            setErrors({});
            setPartNumberError(false);
            setBrandError(false);
            setDescriptionError(false);
            setErrorMessage('');
            setShowErrors(false);
            setIsDataUpdated(false);
        }
    }, [props.isEdit, editAnnexurePartDetails]);


    const handleopenCloseSnackbar = (open?: any) => {
        setOpenSnackbar(open ? true : false);
    };

    const deleteSelectedParts = () => {
        // Your delete logic
    };

    type ProductInfo = {
        brand: string;
        description: string;
    };

    const formatMaterialGroup = (data: any) => {
        if (data) {
            return data.substring(0, 5).toUpperCase()
        } else {
            return "XXXXX"
        }
    }

    const getUniqueBrands = (brands: any) => {
        let uniqueBrands = brands.filter((c: any, index: any) => {
            return brands.indexOf(c) === index;
        });
        return uniqueBrands;
    }

    const resetData = () => {

    }

    useEffect(() => {
        setIsValid(partNumber && displayName && description);
    }, [partNumber, displayName, description]);

    const handlePartNumberChange = (e: any) => {
        setIsDataUpdated(true);
        setPartNumber(e.target.value);
        setDisplayName('');
        setDescription('');
        setErrorMessage('');
    };

    const handleTierMinChange = (tier: number, value: string) => {
        setIsDataUpdated(true);
        const numericValue = value.replace(/\D/g, '');
        setTiers((prev: any) => {
            const updated = {
                ...prev,
                [`tier${tier}`]: { ...prev[`tier${tier}`], min: numericValue }
            };
            if (tier > 1 && numericValue) {
                const prevTier = `tier${tier - 1}` as TierKey;
                updated[prevTier].max = (parseInt(numericValue) - 1).toString();
            }
            return updated;
        });
    };

    const handlePriceChange = (tier: number, category: string, value: string) => {
        setIsDataUpdated(true);
        setPrices((prev: any) => ({
            ...prev,
            [`tier${tier}`]: {
                ...prev[`tier${tier}`],
                [category]: value
            }
        }));
    };

    const validateTiers = (): boolean => {
        const newErrors: Partial<Record<TierErrorKeys, string>> = {};

        const getMin = (tier: Tier): number =>
            parseInt(tiers[`tier${tier}` as TierKey].min || '');

        const getMax = (tier: Tier): number =>
            parseInt(tiers[`tier${tier}` as TierKey].max || '');

        // Tier 1 Min
        if (!tiers.tier1.min) {
            newErrors.tier1Min = 'Tier 1 Min Qty is required.';
        }

        // Tier 2 Min
        if (!tiers.tier2.min) {
            newErrors.tier2Min = 'Tier 2 Min Qty is required.';
        } else if (getMin(2) <= getMin(1)) {
            newErrors.tier2Min = 'Tier 2 Min Qty should be greater than Tier 1 Min Qty.';
        }

        // Tier 3 Min
        if (!tiers.tier3.min) {
            newErrors.tier3Min = 'Tier 3 Min Qty is required.';
        } else if (getMin(3) <= getMin(2)) {
            newErrors.tier3Min = 'Tier 3 Min Qty should be greater than Tier 2 Min Qty.';
        }

        // Tier 3 Max (optional but if present, must be > min)
        if (tiers.tier3.max && getMax(3) <= getMin(3)) {
            newErrors.tier3Max = 'Tier 3 Max should be greater than Tier 3 Min.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validatePrices = (): boolean => {
        const newErrors: Partial<Record<TierErrorKeys, string>> = {};

        [1, 2, 3].forEach(tier => {
            const tierKey = `tier${tier}` as TierKey;

            const goldStr = prices[tierKey]?.gold;
            const platinumStr = prices[tierKey]?.platinum;
            const eliteStr = prices[tierKey]?.elite;

            const gold = parseFloat(goldStr ?? '');
            const platinum = parseFloat(platinumStr ?? '');
            const elite = parseFloat(eliteStr ?? '');

            const goldKey = `${tierKey}Gold` as TierErrorKeys;
            const platinumKey = `${tierKey}Platinum` as TierErrorKeys;
            const eliteKey = `${tierKey}Elite` as TierErrorKeys;

            // Validate Gold
            if (!goldStr || isNaN(gold)) {
                newErrors[goldKey] = 'Gold price is required.';
            }

            // Validate Platinum
            if (!platinumStr || isNaN(platinum)) {
                newErrors[platinumKey] = 'Platinum price is required.';
            } else if (!isNaN(gold) && platinum >= gold) {
                newErrors[platinumKey] = 'Price should be less than Gold category.';
            }

            // Validate Elite
            if (!eliteStr || isNaN(elite)) {
                newErrors[eliteKey] = 'Elite price is required.';
            } else if (!isNaN(platinum) && elite >= platinum) {
                newErrors[eliteKey] = 'Price should be less than Platinum category.';
            }
        });

        setErrors(prev => ({ ...prev, ...newErrors }));
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {
        setShowErrors(true);

        const isTierValid = validateTiers();
        const isPriceValid = validatePrices();

        const safePartNumber = typeof partNumber === 'string' ? partNumber.trim() : '';
        const safeDescription = typeof description === 'string' ? description.trim() : '';

        let hasError = false;

        if (!safePartNumber) {
            setErrorMessage('Part number is required.');
            setPartNumberError(true);
            hasError = true;
        } else {
            setPartNumberError(false);
        }

        // console.log("-----------", brands)
        // if (!Array.isArray(brands) || brands.length === 0) {
        //     setBrandError(true);
        //     hasError = true;
        // } else {
        //     setBrandError(false);
        // }

        if (!Array.isArray(brands) || brands.length === 0) {
            setBrandError(false);
        } else {
            setBrandError(false);
        }

        if (!safeDescription) {
            setDescriptionError(true);
            hasError = true;
        } else {
            setDescriptionError(false);
        }

        if (hasError) {
            setShowErrorMessage("Please fill all mandatory fields in both tabs.");
            handleopenCloseErrorSnackbar(true);
            return;
        }
        if (isTierValid && isPriceValid && props.isEdit) {
            updateAnnexureOnClickSave();
        }
        if (!props.isEdit) {
            if (isTierValid && isPriceValid && !props.isEdit) {
                addAnnexureOnClickSave();
            } else if (!props.isEdit) {
                setShowErrorMessage("Please fill all mandatory fields in both Tabs.");
                handleopenCloseErrorSnackbar(true);
                handleopenCloseSnackbar(false);
            }
        }
    };

    const handleTabChange = (e: any, newValue: number) => setActiveTab(newValue);
    type PriceCategory = 'gold' | 'platinum' | 'elite';

    const handleTierMaxChange = (tier: number, value: string) => {
        setIsDataUpdated(true);
        const tierKey = `tier${tier}` as TierKey;
        setTiers(prev => ({
            ...prev,
            [tierKey]: {
                ...prev[tierKey],
                max: value
            }
        }));
    };

    const getBrandDisplayName = (code: string): string => {
        return brandDisplayMapping[code] || code;
    };

    useEffect(() => {
        if (!productsData?.data?.data || !materialGroups?.data?.data) return;

        const products = productsData.data.data;
        const groups = materialGroups.data.data;

        if (products.length === 0 || groups.length === 0) return;

        const product = products[0];
        const productMaterialGroupValue =
            product?.attributes?.materialGroup?.value;

        if (!productMaterialGroupValue) return;

        const productMaterialPrefix =
            productMaterialGroupValue.substring(0, 5);

        // Find matching group
        const matchedGroup = groups.find(
            (group: any) =>
                Array.isArray(group.materialGroup) &&
                group.materialGroup.includes(productMaterialPrefix)
        );
        // Get display name from common mapping using code
        if (matchedGroup?.code && description) {
            const displayBrandName = getBrandDisplayName(matchedGroup.code);
            setDisplayName(displayBrandName);
        } else {
            setDisplayName("");
        }
    }, [productsData, materialGroups, description]);

    const handlePartSearchSubmit = async () => {
        if (typeof partNumber !== 'string' || !partNumber.trim()) {
            setErrorMessage('Part number is required.');
            setPartNumberError(true);
            return;
        }

        const data: any = await dispatch(
            searchProducts(
                customerTierType,
                partNumber,
                enquirySessionId,
                firstName,
                "",
                b2bUserId,
                [{ productId: partNumber, quantity: 1 }]
            )
        );

        const product = data?.data?.[0];

        const existingPartNumbers = getAnnexureListData?.data?.data?.productData?.map((p: any) => p.partNumber) || [];

        if (existingPartNumbers.includes(partNumber)) {
            setShowErrorMessage('This Part Number already exists.');
            handleopenCloseErrorSnackbar(true);
            handleopenCloseSnackbar(false);
            return;
        }

        if (data && data.error) {
            setShowErrorMessage('Not a valid part. Please enter a valid part number.');
            handleopenCloseErrorSnackbar(true);
            handleopenCloseSnackbar(false);
        }

        if (partNumber !== "" || partNumber !== null || partNumber !== undefined) {
            setPartNumberError(false);
        }

        if (!Array.isArray(brands) || brands.length === 0) {
            setBrandError(false);
        } else {
            setBrandError(false);
        }

        if (description !== "" || description !== null || description !== undefined) {
            setDescriptionError(false);
        }

        const dynamicDescription =
            product?.attributes?.materialDescription?.value ||
            product?.description?.EN ||
            '';

        const brand = displayName

        // setDisplayName(brands);
        setDescription(dynamicDescription);
        setErrorMessage('');
        setProductList([
            ...productList,
            {
                partNumber,
                brand,
                description: dynamicDescription,
            }
        ]);
    };

    const addAnnexureOnClickSave = async () => {
        setLoading(true);
        let payload = {
            "partNumber": partNumber.trim(),
            "brand": displayName,
            "description": description,
            "quantityTierRange": {
                "tier_1": {
                    "minQty": tiers.tier1.min,
                    "maxQty": tiers.tier1.max,
                },
                "tier_2": {
                    "minQty": tiers.tier2.min,
                    "maxQty": tiers.tier2.max
                },
                "tier_3": {
                    "minQty": tiers.tier3.min,
                    "maxQty": tiers.tier3.max
                }
            },
            "priceTierRange": {
                "tier_1": {
                    "gold": prices.tier1.gold,
                    "platinum": prices.tier1.platinum,
                    "elite": prices.tier1.elite
                },
                "tier_2": {
                    "gold": prices.tier2.gold,
                    "platinum": prices.tier2.platinum,
                    "elite": prices.tier2.elite
                },
                "tier_3": {
                    "gold": prices.tier3.gold,
                    "platinum": prices.tier3.platinum,
                    "elite": prices.tier3.elite
                }
            },
            "updatedBy": firstName,
            "empId": webApplicationLoginId
        }
        let responseData: any = await dispatch(addAnnxurePart(payload))
        if (responseData && responseData.status === 400) {
            setShowErrorMessage(typeof responseData?.error === 'string' ? responseData?.error : responseData?.error?.error ? responseData?.error?.error : 'Error Occured');
            // setShowErrorMessage(responseData && responseData.error);
            handleopenCloseErrorSnackbar(true);
            handleopenCloseSnackbar(false);
            setLoading(false);
        } else {
            setTimeout(() => {
                setSuccessMessage("Part Added Successfully.");
                handleopenCloseSnackbar(true);
                setLoading(false);
            }, 2000)
            setPartNumberError(false);
            props.setOpenDialog();
            dispatch(getAnnexureList(0, rowsPerPage, ""));
        }
    }

    const updateAnnexureOnClickSave = async () => {
        setLoading(true);
        let payload = {
            "partNumber": partNumber,
            "brand": displayName,
            "description": description,
            "quantityTierRange": {
                "tier_1": {
                    "minQty": tiers.tier1.min,
                    "maxQty": tiers.tier1.max,
                },
                "tier_2": {
                    "minQty": tiers.tier2.min,
                    "maxQty": tiers.tier2.max
                },
                "tier_3": {
                    "minQty": tiers.tier3.min,
                    "maxQty": tiers.tier3.max
                }
            },
            "priceTierRange": {
                "tier_1": {
                    "gold": prices.tier1.gold,
                    "platinum": prices.tier1.platinum,
                    "elite": prices.tier1.elite
                },
                "tier_2": {
                    "gold": prices.tier2.gold,
                    "platinum": prices.tier2.platinum,
                    "elite": prices.tier2.elite
                },
                "tier_3": {
                    "gold": prices.tier3.gold,
                    "platinum": prices.tier3.platinum,
                    "elite": prices.tier3.elite
                }
            },
            "updatedBy": firstName,
            "empId": webApplicationLoginId
        }
        let responseData: any = await dispatch(updateAnnexurePart(payload))
        if (responseData && responseData.status === 400) {
            setShowErrorMessage(typeof responseData?.error === 'string' ? responseData?.error : responseData?.error?.error ? responseData?.error?.error : 'Error Occured');
            // setShowErrorMessage(responseData && responseData.error);
            handleopenCloseErrorSnackbar(true);
            handleopenCloseSnackbar(false);
            setLoading(false);
        } else {
            setTimeout(() => {
                setSuccessMessage("Part Added Successfully.");
                handleopenCloseSnackbar(true);
                setLoading(false);
            }, 2000)
            setPartNumberError(false);
            props.setOpenDialog();
            dispatch(getAnnexureList(0, rowsPerPage, ""));
        }
    }

    return (
        <Fragment>
            {loading && <FullscreenLoader />}
            <Snackbar
                open={openSnackbar}
                handleopenClose={() => {
                    handleopenCloseSnackbar(false)
                }} message={successMessage} />
            <Snackbar
                open={openErrorSnackbar}
                type="error"
                handleopenClose={() => {
                    handleopenCloseErrorSnackbar(false)
                }} message={showErrorMessage} />
            <div className={classes.root}>
                <Toolbar
                    className={clsx(classes.root)}>
                    <div className="col-12 mb-3 mt-3">
                        <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                            <h4 className="shift-to-party-page-title">
                                <div className={classes.addUpdateDailogTitle}>
                                    {props.isEdit === true ? "Update Part Details" : "Add New Part"}
                                </div>
                                <IconButton aria-label="close" className="float-right" onClick={() => {
                                    if (isDataUpdated === true) {
                                        setOpenDialog(true);
                                    } else {
                                        props.setOpenDialog();
                                    }
                                }}>
                                    <CloseIcon />
                                </IconButton>
                            </h4>
                        </Typography>
                    </div>
                </Toolbar>
            </div>
            <div className="form-section p-4">
                {/* Part number input */}
                {props.isEdit === true ?
                    <Tooltip title="The Part Number, Brand, and Description cannot be edited." placement="top">
                        <div className="d-flex mb-3" style={{ position: 'relative' }}>
                            <TextField
                                required
                                className="col-12 rounded-input-dealer mw-200p mr-3"
                                label="Part No."
                                variant="outlined"
                                value={partNumber}
                                error={partNumberError}
                                disabled={props.isEdit ? true : false}
                                onChange={handlePartNumberChange}
                                InputProps={{
                                    style: {
                                        backgroundColor: '#fff',
                                        borderRadius: '24px',
                                        paddingRight: 40,
                                        color: '#8D9797', // dark text
                                    }
                                }}
                                inputProps={{
                                    pattern: '[A-Za-z0-9-_]*'
                                }}
                            />
                            <IconButton
                                disabled={props.isEdit ? true : false}
                                onClick={(index: any) => {
                                    handlePartSearchSubmit();
                                }}
                                style={{
                                    position: 'absolute',
                                    right: 12,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    backgroundColor: '#F2F4F7',
                                    borderRadius: '5px 30px 30px 5px',
                                    height: 40,
                                    width: 40,
                                    padding: 0
                                }}
                            >
                                <ArrowForwardIcon style={{ color: '#667085', fontSize: 25 }} />
                            </IconButton>
                        </div>
                    </Tooltip>
                    :
                    <div className="d-flex mb-3" style={{ position: 'relative' }}>
                        <TextField
                            required
                            className="col-12 rounded-input-dealer mw-200p mr-3"
                            label="Part No."
                            variant="outlined"
                            value={partNumber}
                            error={partNumberError}
                            disabled={props.isEdit ? true : false}
                            onChange={handlePartNumberChange}
                            InputProps={{
                                style: {
                                    backgroundColor: '#fff',
                                    borderRadius: '24px',
                                    paddingRight: 40,
                                    color: '#000', // dark text
                                }
                            }}
                            inputProps={{
                                pattern: '[A-Za-z0-9-_]*'
                            }}
                        />
                        <IconButton
                            disabled={props.isEdit ? true : false}
                            onClick={(index: any) => {
                                handlePartSearchSubmit();
                            }}
                            style={{
                                position: 'absolute',
                                right: 12,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                backgroundColor: '#F2F4F7',
                                borderRadius: '5px 30px 30px 5px',
                                height: 40,
                                width: 40,
                                padding: 0
                            }}
                        >
                            <ArrowForwardIcon style={{ color: '#667085', fontSize: 25 }} />
                        </IconButton>
                    </div>}
                {errorMessage && errorMessage === "Part number is required." ? <div className="mx-auto text-left px-3 mb-3 text-red">{errorMessage}</div> : ""}

                {/* Brand + Description */}
                <div className="d-flex mb-3">
                    <TextField
                        required
                        label="Brand" variant="outlined" className="rounded-input-dealer mw-200p mr-3"
                        fullWidth disabled value={displayName}
                        InputProps={{
                            style: {
                                color: '#8D9797', // dark text
                            },
                        }}
                    // error={brandError}
                    />
                    <TextField
                        required
                        label="Description" variant="outlined" className="rounded-input-dealer mw-200p"
                        fullWidth disabled value={description}
                        InputProps={{
                            style: {
                                color: '#8D9797', // dark text
                            },
                        }}
                    // error={descriptionError}
                    />
                </div>

                {/* Tabs */}
                <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary" textColor="primary" className="mb-3">
                    <Tab label="Set Quantity for Tier Range" />
                    <Tab label="Set Price for Tier Range" />
                </Tabs>


                {activeTab === 0 && (
                    <div className='pt-1 pb-0'>
                        {[1, 2, 3].map((tier: number) => {
                            const tierKey = `tier${tier}` as TierKey;
                            const minKey = `tier${tier}Min` as TierErrorKeys;
                            const maxKey = `tier${tier}Max` as TierErrorKeys;
                            const prevTierKey = `tier${tier - 1}` as TierKey;

                            return (
                                <div className="d-flex mb-3 mt-2" key={`tier-${tier}`}>
                                    <div className="mr-3 pt-3">Tier {tier}</div>

                                    <Box display="flex" flexDirection="column" maxWidth="250px" width="100%">
                                        <TextField
                                            label="Min Qty"
                                            variant="outlined"
                                            className="rounded-input-dealer mr-3"
                                            value={tiers[tierKey]?.min || ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // allow only digits, max 5
                                                if (/^\d{0,5}$/.test(value)) {
                                                    handleTierMinChange(tier, value);
                                                }
                                            }}
                                            disabled={tier !== 1 && !tiers[prevTierKey]?.min}
                                            error={!!errors[minKey]}
                                            helperText={errors[minKey] || ''}
                                            required
                                            fullWidth
                                        />
                                    </Box>
                                    <div className='px-2'></div>
                                    <Box display="flex" flexDirection="column" maxWidth="250px" width="100%">
                                        <TextField
                                            label="Max Qty"
                                            variant="outlined"
                                            className="rounded-input-dealer"
                                            value={tiers[tierKey]?.max || ''}
                                            onChange={
                                                tier === 3
                                                    ? (e) => {
                                                        const value = e.target.value;
                                                        // Allow only numbers and limit to 5 digits
                                                        if (/^\d{0,5}$/.test(value)) {
                                                            handleTierMaxChange(tier, value);
                                                        }
                                                    }
                                                    : undefined
                                            }
                                            disabled={tier !== 3}
                                            error={!!errors[maxKey]}
                                            helperText={errors[maxKey] || ''}
                                            fullWidth
                                            InputProps={
                                                tier !== 3
                                                    ? {
                                                        style: {
                                                            color: '#8D9797',
                                                        },
                                                    }
                                                    : undefined
                                            }
                                        />
                                    </Box>
                                </div>
                            );
                        })}

                        <p className="text-note mt-4">
                            Note: If Tier 3 Maximum Quantity is kept blank then it will take the quantity beyond Minimum Quantity of Tier 3.
                        </p>
                    </div>
                )}

                {activeTab === 1 && (
                    <div className='pt-2'>
                        {[1, 2, 3].map((tier: number) => {
                            const tierKey = `tier${tier}` as TierKey;

                            return (
                                <div
                                    className='mb-0 mt-0'
                                    key={`price-tier-${tier}`}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        marginBottom: '0px',
                                        marginTop: '0px',
                                    }}
                                >
                                    <div
                                        style={{
                                            marginRight: '12px',
                                            paddingTop: '12px', // reduced from 20px
                                            width: '60px',
                                            fontWeight: 500,
                                        }}
                                    >
                                        Tier {tier}
                                    </div>

                                    {(['gold', 'platinum', 'elite'] as PriceCategory[]).map((category) => {
                                        const fieldKey = `tier${tier}${category[0].toUpperCase() + category.slice(1)}` as TierErrorKeys;

                                        return (
                                            <TextField
                                                key={fieldKey}
                                                label={category.charAt(0).toUpperCase() + category.slice(1)}
                                                variant="outlined"
                                                required
                                                className="rounded-input-dealer mw-200p mr-3"
                                                value={prices[tierKey]?.[category] || ''}
                                                error={showErrors && !!errors[fieldKey]}
                                                helperText={showErrors ? errors[fieldKey] || ' ' : ' '}
                                                onChange={(e) => {
                                                    setIsDataUpdated(true);
                                                    const rawValue = e.target.value;
                                                    const sanitizedValue = rawValue
                                                        .replace(/[^0-9.]/g, '')
                                                        .replace(/(\..*)\./g, '$1');

                                                    setPrices((prev) => ({
                                                        ...prev,
                                                        [tierKey]: {
                                                            ...prev[tierKey],
                                                            [category]: sanitizedValue,
                                                        },
                                                    }));

                                                    const gold = parseFloat(
                                                        category === 'gold' ? sanitizedValue : prices[tierKey]?.gold || ''
                                                    );
                                                    const platinum = parseFloat(
                                                        category === 'platinum' ? sanitizedValue : prices[tierKey]?.platinum || ''
                                                    );
                                                    const elite = parseFloat(
                                                        category === 'elite' ? sanitizedValue : prices[tierKey]?.elite || ''
                                                    );

                                                    const goldKey = `${tierKey}Gold` as TierErrorKeys;
                                                    const platinumKey = `${tierKey}Platinum` as TierErrorKeys;
                                                    const eliteKey = `${tierKey}Elite` as TierErrorKeys;

                                                    const updatedErrors: Partial<Record<TierErrorKeys, string>> = {};

                                                    if (
                                                        category === 'platinum' &&
                                                        !isNaN(gold) &&
                                                        !isNaN(platinum) &&
                                                        platinum >= gold
                                                    ) {
                                                        updatedErrors[platinumKey] = 'Price should be less than Gold category';
                                                    }

                                                    if (
                                                        category === 'elite' &&
                                                        !isNaN(platinum) &&
                                                        !isNaN(elite) &&
                                                        elite >= platinum
                                                    ) {
                                                        updatedErrors[eliteKey] = 'Price should be less than Platinum category';
                                                    }

                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        ...updatedErrors,
                                                        ...(category === 'platinum' && platinum < gold
                                                            ? { [platinumKey]: '' }
                                                            : {}),
                                                        ...(category === 'elite' && elite < platinum
                                                            ? { [eliteKey]: '' }
                                                            : {}),
                                                    }));
                                                }}
                                                style={{
                                                    minWidth: '200px',
                                                    maxWidth: '200px',
                                                    marginRight: '12px',
                                                }}
                                                InputProps={{
                                                    style: {
                                                        height: '50px', // reduced height
                                                        boxSizing: 'border-box',
                                                        padding: '5px 8px', // adjusted for vertical alignment
                                                    },
                                                }}
                                                FormHelperTextProps={{
                                                    style: {
                                                        minHeight: '15px',
                                                        marginTop: '2px',
                                                    },
                                                }}
                                            />
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                )}

                <React.Fragment>
                    <Dialog
                        disableBackdropClick={true}
                        open={openDialog}
                        fullWidth={true}
                        maxWidth={'sm'}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <div className={`mt-2 ${classes.icon}`}>
                                <WarningIcon className="delete-warning" fontSize="small" />
                            </div>
                            <div>
                                <DialogContentText id="alert-dialog-description">
                                    <div className={`mt-4 ${classes.logoutText}`}>
                                        Do you wish to proceed without saving the data ?
                                    </div>
                                </DialogContentText>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <><Button
                                className={`mx-4 ${classes.yes}`}
                                onClick={async () => {
                                    props.setOpenDialog();
                                    setOpenDialog(false);
                                }}>Proceed</Button>
                                <Button
                                    className={`mr-4 ${classes.cancel}`}
                                    onClick={() => {
                                        setOpenDialog(false);
                                    }}>Cancel</Button></>
                        </DialogActions>
                    </Dialog>
                </React.Fragment>
                <DialogActions className="mt-4 justify-content-end mb-2">
                    <Button
                        variant="contained" className="border-left rounded-pill w-150p"
                        color="primary"
                        onClick={handleSave}
                    >
                        {props.isEdit ? "Update" : "Save"}
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.closeButton}
                        onClick={() => {
                            if (isDataUpdated === true) {
                                setOpenDialog(true);
                            } else {
                                props.setOpenDialog();
                            }
                        }
                        }
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </div>
        </Fragment >
    );
}
